import {getOneYearTime} from "../../lib/hos/until"

export const referralFormMixin = {
  created() {
    this.setFormReferralType();
    this.setDefaultTime();//设置时间框默认时间
  },
  methods: {
    setFormReferralType() {
      const {params} = this.$route;
      if (params.type === 'outpatient') {
        this.form.referralType = '门诊转诊';
        this.form.patInhosnoType = '门诊';
      } else if (params.type === 'hospitalization') {
        this.form.referralType = '住院转诊';
        this.form.patInhosnoType = '住院';
      }
    },

    resetFormReferral() {
      this.form.pageNum = 1;
      this.form.patName = undefined;
      this.setDefaultTime();//设置时间框默认时间
      // if (this.form.startTime) this.form.startTime = undefined;
      // if (this.form.endTime) this.form.endTime = undefined;
    },

    setDefaultTime(){
      const timeObj = getOneYearTime();
      this.form.endTime = timeObj.end;
      this.form.startTime = timeObj.start;
    }
  },
};
